import React, { PureComponent } from 'react';
import { NormalizedSeries, IChartGroup } from 'types';
// Components
import styles from './chart.scss';
import { ICON_DOWN, ICON_RIGHT } from 'icons';
import { CustomTransition } from 'ui/transition';
import ChartAddGroupBtn from './chart-add-group-btn';
import ChartSeriesLabel from './chart-series-label';
import ResizeBar from 'components/resize-bar';
import { DEFAULT_CHART_HEIGHT, CHART_TARGET_TYPE } from './utils';
import { DropTarget } from 'react-dnd';

interface ChartSeriesHeaderProps {
  index: number;
  series: NormalizedSeries[];
  groups: IChartGroup[];
  onGroupUpdate: (groups: IChartGroup[]) => void;
}

@DropTarget(CHART_TARGET_TYPE, {}, (connect, monitor) => ({
  canDrop: monitor.canDrop(),
  isOver: monitor.isOver()
}))
class ChartSeriesHeader extends PureComponent<ChartSeriesHeaderProps> {
  handleUpdateGroup(update: Partial<IChartGroup>) {
    const { index, onGroupUpdate } = this.props;

    const groups = this.props.groups.slice();
    const group = groups[index];
    groups[index] = { ...group, ...update };
    onGroupUpdate(groups);
  }

  handleResize = deltaHeight => {
    const group = this.props.groups[this.props.index];
    this.handleUpdateGroup({ height: (group.height || DEFAULT_CHART_HEIGHT) + deltaHeight });
  };
  handleToggle = () => {
    const group = this.props.groups[this.props.index];
    this.handleUpdateGroup({ collapsed: !group.collapsed });
  };

  render() {
    const { index, canDrop, height, groups, series, children, onGroupUpdate } = this.props;
    const group = groups[index];
    let cl = `row v-center ${styles.separator}`;
    if (group.collapsed) cl += ' ' + styles.collapsed;
    return (
      <div style={{ position: 'relative' }} ref={ref => (this.holder = ref)}>
        <div className={cl}>
          {series.map(s => (
            <ChartSeriesLabel key={s.id} series={s} />
          ))}
          <ChartAddGroupBtn
            groupIndex={index}
            series={series}
            groups={groups}
            onGroupUpdate={onGroupUpdate}
          />
          <span className="flex" />
          <div className={styles.collapseBtn} onClick={this.handleToggle}>
            {group.collapsed ? ICON_RIGHT : ICON_DOWN}
          </div>
        </div>
        {!group.collapsed && (
          <div>
            {children}
            {!canDrop && <ResizeBar axis="y" onResize={this.handleResize} />}
            <ChartAddGroupBtn
              className={styles.addNewGroupBtn}
              newGroup
              groupIndex={index}
              groups={groups}
              onGroupUpdate={onGroupUpdate}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ChartSeriesHeader;
